/**
 * Created by YingJieCHAI on 2018/5/17.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './home.component';
import { homeRoutes } from './home.routes';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    HomeComponent
  ],
  imports: [
    RouterModule.forChild(homeRoutes),
    FormsModule,
    CommonModule
  ],
  providers: [],
  bootstrap: []
})
export class HomeModule { }
